// This file is automatically compiled by Webpack, along with any other files

import Rails from "rails-ujs"

// init Rails UJS
Rails.start();

// Load the main application
require('../src/main').default();

